var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsBurgerVMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.826 2.156a1.386 1.386 0 11-2.764-.209 1.386 1.386 0 012.764.209zM2.828 7.341a1.385 1.385 0 11-2.771 0 1.385 1.385 0 012.77 0zM2.826 12.584a1.386 1.386 0 11-2.756.287 1.386 1.386 0 012.756-.287z",
    fill: "#C4C4C4"
  })));
}
export default SvgDotsBurgerVMenu;